<template>
  <div class="modal fade" id="video-modal" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header hide">
        </div>
        <div class="modal-body">
          <div class="row text-right">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- 16:9 aspect ratio -->
          <div class="embed-responsive embed-responsive-16by9">
            <iframe class="embed-responsive-item" v-bind:src="videoUrl" id="video"  allowscriptaccess="always" target="_parent">></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda'

export default {
  components: {
    VueLadda
  },
  props: ['value', 'videoUrl'],
  name: 'VideoModal',
  watch: {
  },
  methods: {
  },
  data () {
    return {
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  mounted () {
    $('#video-modal').modal()
    $('#video-modal').on('hidden.bs.modal', (e) => {
      this.$emit('input', false)
    })
  },
  beforeMount () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/VideoModal.vue